/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScopeOfCareDto } from '../../models/scope-of-care-dto';

export interface GetCustomerScopesOfCare$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * Optional filter to get only scopesOfCare where archived == true/false
 */
  archived?: boolean;
}

export function getCustomerScopesOfCare(http: HttpClient, rootUrl: string, params: GetCustomerScopesOfCare$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScopeOfCareDto>>> {
  const rb = new RequestBuilder(rootUrl, getCustomerScopesOfCare.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('archived', params.archived, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ScopeOfCareDto>>;
    })
  );
}

getCustomerScopesOfCare.PATH = '/customers/{customerId}/scopes-of-care';
